import {Component} from "@angular/core";

@Component({
    styleUrls: ['./webmaster.scss'],
    templateUrl: './webmaster.html'
})
export class AdminWebmasterComponent {

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/webmaster/webmaster.ts